import {MenuOptions} from '@kilobytelab/types';

export const PROVINCIAS: string[] = ('Álava-Albacete-Alicante/Alacant-Almería-Asturias-Ávila-Badajoz-Barcelona-Burgos-Cáceres-Cádiz-Cantabria-' +
  'Castellón/Castelló-Ceuta-Ciudad Real-Córdoba-Cuenca-Girona-Las Palmas-Granada-Guadalajara-Guipúzcoa-Huelva-Huesca-Illes Balears-' +
  'Jaén-A Coruña-La Rioja-León-Lleida-Lugo-Madrid-Málaga-Melilla-Murcia-Navarra-Ourense-Palencia-Pontevedra-Salamanca-Segovia-' +
  'Soria-Tarragona-Santa Cruz de Tenerife-Teruel-Toledo-Valencia/Valéncia-Valladolid-Vizcaya-Zamora-Zaragoza')
  .split('-').map(prov => prov);
/*** SEGUN INSTRUCCIONES AEAT ****/
/*** https://www.agenciatributaria.es/static_files/Sede/Procedimiento_ayuda/GI45/Ayuda/Ayuda_guarderias2020.pdf *************/
export const CCAA: string[] = [null, 'Andalucía', 'Aragón', 'Asturias, Principado de', 'Baleares', 'Canarias', 'Cantabria', 'Castilla y León',
  'Castilla - La Mancha', 'Cataluña', 'Comunidad Valenciana', 'Extremadura', 'Galicia', 'Madrid, Comunidad de', 'Murcia, Región de',
  'Navarra, Comunidad Foral de', 'País Vasco', 'Rioja, La', 'Ministerio de Educación'];
export const TIPOS: {tipo: string, nombre: string, class: string}[] = [
  {tipo: '0-1', nombre: 'BEBÉS', class: 'primary'},
  {tipo: '1-2', nombre: 'PEQUEÑ@S', class: 'secondary'},
  {tipo: '2-3', nombre: 'MAYORES', class: 'tertiary'},
  {tipo: '1 MIXTA', nombre: 'MIXTA UN AÑO', class: 'success'},
  {tipo: '2 MIXTA', nombre: 'MIXTA DOS AÑOS', class: 'warning'},
  {tipo: '2', nombre: 'DOS AÑOS', class: 'danger'}
]; // En orden !importante
export const ESTADOS: string[] = ['alta', 'matriculado', 'verano', 'campus', 'baja']; // En minúsculas !importante
export const SEXOS: MenuOptions[] = [
  {text: 'NO INFO', option: ''},
  {text: 'HOMBRE', option: 'HOMBRE'},
  {text: 'MUJER', option: 'MUJER'}
];
export const MATERIAL: {tipo: string, color: string}[] = [
  {tipo: 'ANUAL', color: 'primary'},
  {tipo: 'SEMESTRAL', color: 'tertiary'},
  {tipo: 'TRIMESTRAL', color: 'danger'},
  {tipo: 'PRORRATEADO', color: 'secondary'},
  {tipo: 'EN TICKET', color: 'warning'},
];
export const MESES: string[] = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];
export const NEXT: {valor: string, texto: string}[] = [
  {valor: '', texto: 'SIN CAMBIOS'},
  {valor: 'baja', texto: 'BAJA'}  ];
export const FESTIVOS: string[] = ['', 'FESTIVO', 'CERRADO CONVENIO', 'CERRADO PARCIAL'];
export const ZERODATE: string = '0000-00-00';
export const TIMEOUT_MS: number = 15000;